module.exports = __webpack_public_path__ + "static/media/house_rank.f85c2352.csv";